export default "__VITE_ASSET__oOVqd7o___"